import { Box, Grid2 } from "@mui/material";
import { styled } from "@mui/material/styles";
import { NormalContainer } from "./NormalComponent";
import { TopHeadSection } from "./NormalComponent";
import { IconButton } from "@mui/material";
import ArrowLeftIcon from '@mui/icons-material/ArrowLeft';
import ArrowRightIcon from '@mui/icons-material/ArrowRight';
import { useRef } from "react";

const ScrollContainer = styled(Grid2)(() => ({
    overflowX: "auto",
    display: "flex",
    flexWrap: "nowrap",
    gap: "15px",
    scrollbarWidth: "none",
    "&::-webkit-scrollbar": { display: "none" },
    scrollBehavior: "smooth",
}));

export const ScrollButton = styled(IconButton)(({ sx }) => ({
    position: "absolute",
    zIndex: 1,
    background: "#fff",
    boxShadow: "0px 4px 4px 0px #4169E11A",
    padding: 0,
    "&:hover": {
        background: "#fff",
    },
    ...sx
}));

const ScrollContainerWithHeader = ({ children, headerText, customPadding, RightContent, boxShadow }) => {
    const scrollRef = useRef(null);

    const scroll = (direction) => {
        if (scrollRef.current) {
            const scrollAmount = 300; // Adjust scroll amount as needed
            scrollRef.current.scrollBy({ left: direction === "left" ? -scrollAmount : scrollAmount, behavior: "smooth" });
        }
    };
    return (
        <NormalContainer container padding={customPadding} boxShadow={boxShadow} >
            <TopHeadSection headerText={headerText} RightContent={RightContent} />
            <Grid2 
                width={"100%"} 
                sx={{ 
                    display: "flex", 
                    alignItems: "center", 
                    position: "relative",
                    "&:hover .scroll-btn": {
                        opacity: 1,
                    }
                }}
            >
                <ScrollButton className="scroll-btn" onClick={() => scroll("left")} sx={{ opacity: 0, transition: "opacity 0.3s" }} style={{ left: 0, zIndex: 101 }}>
                    <ArrowLeftIcon sx={{ fontSize: "30px" }} />
                </ScrollButton>
                <Grid2 sx={{ overflow: "hidden", flex: 1, position: "relative" }}>
                    <ScrollContainer ref={scrollRef}>{children}</ScrollContainer>
                </Grid2>
                <ScrollButton className="scroll-btn" onClick={() => scroll("right")} sx={{ opacity: 0, transition: "opacity 0.3s" }} style={{ right: 0, zIndex: 101 }}>
                    <ArrowRightIcon sx={{ fontSize: "30px" }} />
                </ScrollButton>
            </Grid2>
        </NormalContainer>
    );
};

export { ScrollContainer, ScrollContainerWithHeader };
